// @flow

import facetsHiddenByConfiguration from '../facets-hidden-by-configuration';
import adaptFacet from '../adapt-facet';
import withFacetConfig
  from '../../../../left-faceted-grid/adapters/with-facet-config';
import facetsHiddenByStrategy from '../facets-hidden-by-strategy';

const adaptFacets = (
    rawFacets: Facet[],
    departmentHidden: boolean,
    priceHidden: boolean,
    ratingsFacetHidden: boolean,
): FacetWithApplied[] => {
  const facets = rawFacets.
      map(withFacetConfig).
      filter(facetsHiddenByConfiguration(departmentHidden, priceHidden, ratingsFacetHidden));
  return facets.
      filter(facetsHiddenByStrategy).
      map(adaptFacet);
};

export default adaptFacets;
